module.exports = __webpack_public_path__ + "img/gall-2.7da5b761.jpg";